import { enTranslations } from './translations.en';

export const ptTranslations: Record<string, string> = {
  ...enTranslations,
  'nav.overview': 'Visão geral',
  'nav.overviewDesc': 'Estado operacional, orquestração e canais de entrega',
  'nav.reception': 'Receção',
  'nav.receptionDesc': 'Listas operacionais, emissão manual e carregamento em massa',
  'nav.administration': 'Administração',
  'nav.administrationDesc':
    'Listas e formulários dedicados para tenants, vendors, localizações, utilizadores e infraestrutura',
  'shell.consoleTitle': 'Consola operacional',
  'shell.consoleDescription':
    'Dashboard multi-tenant para fluxos PMS, processos de receção, provisioning do controlador de rede e distribuição DPSK.',
  'shell.livePosture': 'Estado em tempo real',
  'shell.loadingLocation': 'A carregar o contexto da localização',
  'shell.healthy': 'Fluxo operacional estável',
  'shell.attention': 'Atenção no canal de entrega',
  'shell.authSession': 'Sessão autenticada',
  'shell.guestOperator': 'Operador de demonstração',
  'shell.noRole': 'Sem função',
  'shell.currentWorkspace': 'Área de trabalho atual',
  'shell.workspaceDescription': 'Contexto ativo para a página selecionada.',
  'shell.filters': 'Filtros',
  'shell.tenant': 'Tenant',
  'shell.location': 'Hotel / Localização',
  'shell.language': 'Idioma',
  'shell.theme': 'Tema',
  'shell.theme.system': 'Sistema',
  'shell.theme.light': 'Claro',
  'shell.loadingData': 'A atualizar dados',
  'shell.searchTenant': 'Pesquisar tenant',
  'shell.searchLocation': 'Pesquisar hotel ou localização',
  'shell.noSearchResults': 'Sem resultados',
  'shell.closeFilters': 'Fechar filtros',
  'dialog.cancel': 'Cancelar',
  'dialog.deleteTitle': 'Confirmar eliminação',
  'dialog.extendTitle': 'Confirmar extensão',
  'dialog.revokeTitle': 'Confirmar revogação',
  'shell.noPms': 'Nenhum PMS associado',
  'shell.noController': 'Nenhum controlador associado',
  'shell.tvOn': 'TV ativa',
  'shell.tvPending': 'TV pendente',
  'shell.emailOn': 'Email ativo',
  'shell.emailPending': 'Email pendente',
  'shell.exitSession': 'Sair',
  'auth.mode.mock': 'Modo demo',
  'login.badge': 'Consola operacional hospitality',
  'login.title': 'Acesso seguro à plataforma hospitality.',
  'login.description':
    'Gere tenants, localizações, utilizadores, vendors e credenciais Wi‑Fi numa única consola pensada para a operação diária.',
  'login.inputTitle': 'Tenants e localizações',
  'login.inputBody': 'Controla propriedades, unidades, vendors e definições operacionais num único local.',
  'login.logicTitle': 'Receção e credenciais',
  'login.logicBody':
    'Emite, renova e monitoriza códigos Wi‑Fi para hóspedes, colaboradores e eventos sem passos extra.',
  'login.outputTitle': 'Visibilidade operacional',
  'login.outputBody': 'Consulta o estado do serviço, filas e entrega de credenciais rapidamente.',
  'login.accessMode': 'Acesso',
  'login.demoWorkspace': 'Explorar a plataforma',
  'login.keycloakWorkspace': 'Bem-vindo de volta',
  'login.demoDescription': 'Abre o ambiente de demonstração para explorar os principais fluxos com dados de exemplo.',
  'login.keycloakDescription': 'Entra com a tua conta corporativa para continuar.',
  'login.enterDemo': 'Abrir dashboard demo',
  'login.continueKeycloak': 'Entrar na plataforma',
  'login.readyTitle': 'Gestão centralizada',
  'login.readyBody':
    'Tenants, localizações, unidades, utilizadores e catálogos estão disponíveis numa única consola operacional.',
  'login.supportTitle': 'Operações diárias',
  'login.supportBody':
    'Trabalha com fluxos de receção, credenciais Wi‑Fi e definições de serviço numa experiência mais simples.',
  'login.demoNote': 'O ambiente demo usa dados de exemplo e destina-se apenas a exploração.',
  'login.switchNote': 'Se tiveres problemas no acesso, contacta o administrador do serviço.',
  'overview.context': 'Visão operacional',
  'overview.title': 'Estado da localização selecionada',
  'overview.subtitle':
    'Indicadores rápidos sobre utilização DPSK, mapeamento VLAN e carga operacional do local.',
  'reception.pageKicker': 'Operações de receção',
  'reception.pageTitle': 'Emissão de DPSK e gestão do ciclo de vida',
  'reception.pageDescription':
    'A área de receção está organizada em páginas dedicadas: lista de códigos, emissão manual e importação em massa.',
  'admin.pageKicker': 'Gestão administrativa',
  'admin.pageTitle': 'Tenants, vendors, localizações e utilizadores',
  'admin.pageDescription':
    'A área administrativa usa páginas dedicadas para tenants, catálogos vendor, localizações, utilizadores e infraestrutura.',
  'admin.actions.newRoomAssignment': 'Nova unidade',
  'admin.actions.assignRoom': 'Editar unidade',
  'admin.form.createRoomAssignment': 'Criar unidade',
  'admin.form.updateRoomAssignment': 'Atualizar unidade',
  'admin.form.roomAssignmentDescription':
    'Defina o mapeamento Wi‑Fi de uma única unidade. A configuração fica disponível imediatamente no inventário da localização e nos fluxos da receção.',
  'admin.form.roomNotFound': 'Unidade não encontrada.',
  'admin.form.locationRequiredForRoom':
    'Selecione primeiro uma localização antes de registar uma unidade.',
  'admin.message.roomAssignmentSaved':
    'Configuração de infraestrutura guardada para {name}.',
  'table.pagination.previous': 'Anterior',
  'table.pagination.next': 'Seguinte',
  'table.pagination.summary': '{from}-{to} de {total}',
  'app.badge': 'Lumen Hospitality DPSK',
  'auth.mode.keycloak': 'Keycloak',
  'login.realm': 'Realm',
  'login.clientId': 'Client ID',
  'login.endpoint': 'Endpoint',
  'overview.card.active.label': 'Identidades ativas',
  'overview.card.active.caption': 'DPSK atualmente válidas na localização selecionada',
  'overview.card.scheduled.label': 'Chegadas agendadas',
  'overview.card.scheduled.caption': 'Credenciais já criadas e à espera do check-in ou do início do evento',
  'overview.card.mapped.label': 'Unidades mapeadas',
  'overview.card.mapped.caption': '{rooms} quartos, {publicAreas} áreas comuns, {eventHalls} salas de eventos',
  'overview.card.daily.label': 'Volume diário',
  'overview.card.daily.caption': 'Carga prevista entre PMS, receção e pedidos manuais',
  'overview.locationHealth': 'Estado dos serviços',
  'overview.deliveryChannels': 'Canais de entrega',
  'overview.connected': 'Ligado',
  'overview.fallback': 'Fallback ativo',
  'overview.accounting': 'Accounting',
  'overview.accountingBody': 'Os registos RADIUS permanecem centralizados para compliance e analytics.',
  'overview.operationalFlow': 'Fluxo operacional',
  'overview.flowAligned': 'Alinhado com os cenários do documento',
  'overview.channelMix': 'Mistura de canais',
  'overview.distributionSplit': 'Distribuição da entrega',
  'overview.channelShare': '{share}% do total visível',
  'overview.infrastructure': 'Unidades e VLAN',
  'overview.infrastructureDesc': 'Quartos, áreas comuns e salas de eventos disponíveis nesta localização.',
  'overview.alerts': 'Painel de alertas',
  'overview.alertsTitle': 'Riscos e anomalias atuais',
  'overview.noAlerts': 'Não há anomalias abertas na localização atual.',
  'overview.queue': 'Fila em segundo plano',
  'overview.queueTitle': 'Estado das importações em massa',
  'overview.queueProgress': '{processed}/{total} processados, VLAN de destino {vlan}',
  'overview.credentials': 'Credenciais recentes',
  'overview.credentialsTitle': 'Últimas DPSK emitidas',
  'overview.table.guest': 'Hóspede',
  'overview.table.space': 'Unidade',
  'overview.table.type': 'Tipo',
  'overview.table.vlan': 'VLAN',
  'overview.table.ssid': 'SSID',
  'overview.table.panMode': 'Modo PAN',
  'overview.table.source': 'Origem',
  'overview.table.channels': 'Canais',
  'overview.table.validity': 'Validade',
  'overview.table.devices': 'Dispositivos',
  'overview.flow.trigger.title': 'Acionamento PMS / receção',
  'overview.flow.trigger.body': 'Webhook, formulário do operador ou CSV geram o pedido de acesso.',
  'overview.flow.normalize.title': 'Normalização de identidade',
  'overview.flow.normalize.body':
    'A plataforma atribui hotel, unidade, VLAN e janela temporal de validade.',
  'overview.flow.provision.title': 'Provisioning do controlador de rede',
  'overview.flow.provision.body':
    'A DPSK é associada à VLAN mapeada e ao seu ciclo de vida.',
  'overview.flow.deliver.title': 'Entrega por canais',
  'overview.flow.deliver.body': 'TV, email, dashboard ou impressão recebem o QR code e a palavra-passe.',
  'overview.flow.monitor.title': 'Monitorização e accounting',
  'overview.flow.monitor.body':
    'Utilização, filas, adoção de canais e accounting continuam visíveis para operations.',
  'validation.required': 'Campo obrigatório.',
  'validation.email': 'Introduz um email válido.',
  'validation.minValue': 'Introduz um valor válido.',
  'validation.fixErrors': 'Corrige os campos assinalados antes de guardar.',
  'validation.dateOrder': 'A data final deve ser posterior à data inicial.',
  'validation.selectOne': 'Seleciona pelo menos um elemento.',
  'toast.dismiss': 'Fechar notificação',
  'toast.error.network': 'Não foi possível contactar o serviço backend.',
  'toast.error.badRequest': 'O pedido não é válido.',
  'toast.error.unauthorized': 'Sessão não autorizada. Volta a iniciar sessão.',
  'toast.error.forbidden': 'Não tens permissões para concluir esta operação.',
  'toast.error.notFound': 'O recurso pedido não foi encontrado.',
  'toast.error.conflict': 'A operação não pode ser concluída devido a um conflito de estado.',
  'toast.error.validation': 'Os dados enviados não são válidos.',
  'toast.error.server': 'O servidor devolveu um erro interno.',
  'toast.error.unavailable': 'O serviço está temporariamente indisponível.',
  'toast.error.genericStatus': 'Erro HTTP {status}: pedido sem sucesso.',
  'toast.error.unexpected': 'Ocorreu um erro inesperado durante a chamada HTTP.',
  'channel.tv': 'TV',
  'channel.email': 'Email',
  'channel.dashboard': 'Dashboard',
  'channel.print': 'Impressão',
  'codeSource.pms': 'PMS',
  'codeSource.reception': 'Receção',
  'codeSource.bulk': 'Bulk',
  'queueStatus.queued': 'Em fila',
  'queueStatus.running': 'Em execução',
  'queueStatus.completed': 'Concluído',
  'queueStatus.attention': 'Atenção',
  'spaceKind.room': 'Quarto',
  'spaceKind.public-area': 'Área comum',
  'spaceKind.event-hall': 'Sala de eventos',
  'assignment.room': 'Quarto',
  'assignment.group': 'Grupo',
  'assignment.common': 'Comum',
  'panMode.private': 'Privado',
  'panMode.shared-group': 'Grupo partilhado',
  'panMode.public': 'Comum',
  'role.platform-admin': 'Platform admin',
  'role.tenant-admin': 'Administrador',
  'role.reception': 'Concierge',
  'role.operations': 'Operations',
  'locationCategory.hotel': 'Hotel',
  'locationCategory.resort': 'Resort',
  'locationCategory.conference': 'Espaço de conferências',
  'locationState.active': 'Ativa',
  'locationState.disabled': 'Desativada',
  'locationState.pending': 'Pendente',
  'locationState.stable': 'Estável',
  'locationState.attention': 'Atenção',
  'unitStatus.available': 'Disponível',
  'unitStatus.disabled': 'Desativada',
  'unitStatus.occupied': 'Ocupada',
  'userStatus.active': 'Ativo',
  'userStatus.invited': 'Convidado',
  'userStatus.disabled': 'Desativado',
  'reception.tab.issue': 'Emissão',
  'reception.tab.codes': 'Gestão de códigos',
  'reception.tab.bulk': 'Importação em massa',
  'reception.summary.active': 'Ativos',
  'reception.summary.scheduled': 'Agendados',
  'reception.summary.archived': 'Arquivados',
  'reception.summary.queue': 'Tarefas em massa',
  'reception.issue.kicker': 'Emissão manual',
  'reception.issue.title': 'Criar uma DPSK para hóspedes e casos excecionais',
  'reception.issue.description':
    'Para walk-ins, fornecedores, acesso ao bar ou fallback do PMS. Gere QR code e palavra-passe em texto simples.',
  'reception.fields.firstName': 'Nome',
  'reception.fields.lastName': 'Apelido',
  'reception.fields.email': 'Email',
  'reception.fields.space': 'Unidade',
  'reception.fields.reference': 'Referência de reserva / voucher',
  'reception.fields.validFrom': 'Válido desde',
  'reception.fields.validUntil': 'Válido até',
  'reception.fields.devicesAllowed': 'Dispositivos permitidos',
  'reception.fields.deliveryChannels': 'Canais de entrega',
  'reception.fields.notes': 'Notas do operador',
  'reception.preview.kicker': 'Pré-visualização do voucher',
  'reception.preview.title': 'Cartão do operador',
  'reception.preview.empty': 'Seleciona uma unidade para pré-visualizar o QR code.',
  'reception.preview.guest': 'Hóspede',
  'reception.preview.ssidVlan': 'SSID / VLAN',
  'reception.preview.panMode': 'Modo PAN',
  'reception.preview.expires': 'Expiração',
  'reception.lastCreated': 'Último código criado',
  'reception.lastCreatedEmpty':
    'Gera uma DPSK manual para mostrar aqui o último resumo do voucher.',
  'reception.generate': 'Gerar DPSK',
  'reception.creating': 'A criar...',
  'reception.codes.kicker': 'Gestão de códigos',
  'reception.codes.title': 'Filtra, prolonga ou revoga vouchers',
  'reception.filter.all': 'Todos',
  'reception.filter.pms': 'PMS',
  'reception.filter.reception': 'Receção',
  'reception.filter.bulk': 'Massivo',
  'reception.searchPlaceholder': 'Procurar hóspede ou referência',
  'reception.activeList': 'Ativos / agendados',
  'reception.archivedList': 'Arquivados / inválidos',
  'reception.actions.extend': '+24h',
  'reception.actions.revoke': 'Revogar',
  'reception.actions.new': 'Nova DPSK',
  'reception.actions.backToCodes': 'Voltar aos códigos',
  'reception.actions.showQr': 'Mostrar QR',
  'reception.actions.printQr': 'Imprimir QR',
  'reception.confirm.extend': 'Prolongar o voucher de {name} por 24 horas?',
  'reception.confirm.revoke': 'Revogar o voucher de {name}?',
  'reception.activeEmpty': 'Nenhum código ativo ou agendado corresponde aos filtros atuais.',
  'reception.archivedEmpty': 'Nenhum código arquivado ou revogado corresponde aos filtros atuais.',
  'reception.bulk.kicker': 'Onboarding em massa',
  'reception.bulk.title': 'Importação CSV para grupos e eventos',
  'reception.bulk.loadFile': 'Carregar ficheiro',
  'reception.bulk.mode': 'Modo em massa',
  'reception.bulk.modeShared': 'VLAN de grupo partilhada',
  'reception.bulk.modeIsolated': 'VLAN / isolamento por unidade',
  'reception.bulk.defaultSpace': 'Unidade predefinida',
  'reception.bulk.requestedBy': 'Solicitado por',
  'reception.bulk.csvBody': 'Conteúdo CSV',
  'reception.bulk.queue': 'Colocar importação na fila',
  'reception.bulk.queueing': 'A colocar na fila...',
  'reception.bulk.templateHint':
    'Colunas esperadas: firstName, lastName, email, spaceId, validFrom, validUntil, devicesAllowed, bookingReference',
  'reception.bulk.jobs': 'Estado da fila',
  'reception.bulk.jobsTitle': 'Atividade recente',
  'reception.emptyLocation': 'Seleciona ou cria uma localização com unidades disponíveis.',
  'reception.message.created': 'Criado {id} para {name}.',
  'reception.message.bulkQueued': 'Tarefa {id} colocada na fila com {imported} identidades ({status}).',
  'reception.message.extended': 'Validade prolongada por 24 horas para {id}.',
  'reception.message.revoked': 'Código {id} revogado.',
  'admin.vendorHintTitle': 'Catálogos de vendors',
  'admin.vendorHintBody':
    'Antes de criar ou atualizar uma localização, podes registar os catálogos de vendors de controlador e PMS, para que os dropdowns e os campos de configuração fiquem prontos nos formulários de localização.',
  'admin.card.tenants.label': 'Tenants',
  'admin.card.tenants.caption': 'Portefólio multi-tenant gerido a partir do painel',
  'admin.card.locations.label': 'Localizações',
  'admin.card.locations.caption': 'Hotéis, resorts e venues disponíveis no protótipo',
  'admin.card.users.label': 'Utilizadores',
  'admin.card.users.caption': 'Funções operacionais e atribuições geridas através do estado mock',
  'admin.card.spaces.label': 'Unidades / VLAN',
  'admin.card.spaces.caption': 'Inventário atual de unidades para a localização selecionada',
  'admin.tab.tenants': 'Tenants',
  'admin.tab.locations': 'Localizações',
  'admin.tab.users': 'Utilizadores',
  'admin.tab.controllerVendors': 'Vendors do controlador',
  'admin.tab.pmsVendors': 'Vendors PMS',
  'admin.tab.infrastructure': 'Infraestrutura',
  'admin.tenants.kicker': 'Gestão de tenants',
  'admin.tenants.title': 'Criar e atualizar tenants',
  'admin.locations.kicker': 'Gestão de localizações',
  'admin.locations.title': 'Gerir hotéis, resorts e venues',
  'admin.locations.filterHint':
    'Seleciona um tenant para mostrar apenas as localizações associadas, sem usar os filtros operacionais globais.',
  'admin.users.kicker': 'Gestão de utilizadores',
  'admin.users.title': 'Funções, âmbitos de tenant e âmbitos de localização',
  'admin.controllerVendors.kicker': 'Catálogo de controladores',
  'admin.controllerVendors.title': 'Registar e gerir vendors do controlador',
  'admin.controllerVendors.empty': 'Ainda não existem vendors do controlador registados.',
  'admin.controllerVendors.emptyHint':
    'Adiciona o primeiro vendor do controlador para o disponibilizar no onboarding de localizações.',
  'admin.pmsVendors.kicker': 'Catálogo PMS',
  'admin.pmsVendors.title': 'Registar e gerir vendors PMS',
  'admin.pmsVendors.empty': 'Ainda não existem vendors PMS registados.',
  'admin.pmsVendors.emptyHint':
    'Adiciona o primeiro vendor PMS para o disponibilizar no onboarding de localizações.',
  'admin.infrastructure.kicker': 'Inventário e integrações',
  'admin.infrastructure.title': 'Unidades, VLAN e prontidão dos conectores',
  'admin.form.new': 'Novo',
  'admin.form.reset': 'Repor',
  'admin.form.create': 'Criar',
  'admin.form.update': 'Atualizar',
  'admin.form.name': 'Nome',
  'admin.form.brand': 'Marca / descrição',
  'admin.form.sla': 'SLA',
  'admin.form.coverage': 'Cobertura DPSK %',
  'admin.form.city': 'Cidade',
  'admin.form.category': 'Categoria',
  'admin.form.pms': 'PMS',
  'admin.form.pmsVendor': 'Vendor PMS',
  'admin.form.pds': 'Configuração PDS',
  'admin.form.controller': 'Controlador',
  'admin.form.controllerVendor': 'Vendor do controlador',
  'admin.form.tv': 'Integração TV',
  'admin.form.email': 'Integração email',
  'admin.form.integrations': 'Integrações',
  'admin.form.state': 'Estado',
  'admin.form.dailyCheckIns': 'Check-ins diários',
  'admin.form.activeGuests': 'Hóspedes ativos',
  'admin.form.bulkQueue': 'Fila em massa',
  'admin.form.note': 'Nota operacional',
  'admin.form.timezone': 'Fuso horário',
  'admin.form.linkedTenant': 'Tenant associado',
  'admin.form.role': 'Função',
  'admin.form.status': 'Estado do utilizador',
  'admin.form.tenantScope': 'Âmbito do tenant',
  'admin.form.locationScope': 'Âmbito da localização',
  'admin.form.fieldSchema': 'Esquema de campos',
  'admin.form.fieldName': 'Nome do campo',
  'admin.form.fieldType': 'Tipo de campo',
  'admin.form.fieldsHelp': 'Define pelo menos um campo adicional para o vendor.',
  'admin.form.selectVendor': 'Selecionar vendor',
  'admin.form.selectVendorFirst': 'Seleciona primeiro um vendor para configurar os campos obrigatórios.',
  'admin.form.pmsConfiguration': 'Configuração PMS',
  'admin.form.controllerConfiguration': 'Configuração do controlador',
  'admin.form.vendorConfigurationHint':
    'Preenche todos os campos exigidos pela entrada do catálogo vendor selecionada.',
  'admin.form.noPmsVendorsAvailable':
    'Ainda não existe nenhum vendor PMS disponível. Regista primeiro o catálogo PMS.',
  'admin.form.noControllerVendorsAvailable':
    'Ainda não existe nenhum vendor do controlador disponível. Regista primeiro o catálogo de controladores.',
  'admin.form.addField': 'Adicionar campo',
  'admin.form.removeField': 'Remover campo',
  'admin.form.createControllerVendor': 'Criar vendor do controlador',
  'admin.form.createPmsVendor': 'Criar vendor PMS',
  'admin.form.updateControllerVendor': 'Atualizar vendor do controlador',
  'admin.form.updatePmsVendor': 'Atualizar vendor PMS',
  'admin.form.controllerVendorNotFound': 'Vendor do controlador não encontrado.',
  'admin.form.pmsVendorNotFound': 'Vendor PMS não encontrado.',
  'admin.form.vendorFieldType.string': 'Texto',
  'admin.form.vendorFieldType.number': 'Número',
  'admin.form.vendorFieldType.boolean': 'Booleano',
  'admin.form.vendorFieldType.password': 'Palavra-passe',
  'admin.form.unitType': 'Tipo de unidade',
  'admin.form.assignment': 'Atribuição',
  'admin.form.unitStatus': 'Estado da unidade',
  'admin.list.portfolio': 'Portefólio',
  'admin.list.properties': 'Propriedades',
  'admin.list.coverage': 'Cobertura',
  'admin.list.alerts': 'Alertas',
  'admin.list.noneTenants': 'Ainda não existem tenants registados.',
  'admin.list.noneLocations': 'Não existem localizações disponíveis para o tenant selecionado.',
  'admin.tenants.emptyHint':
    'Cria o primeiro tenant para iniciar o onboarding multi-tenant da plataforma.',
  'admin.actions.edit': 'Editar',
  'admin.actions.toggleStatus': 'Alternar estado',
  'admin.actions.newTenant': 'Novo tenant',
  'admin.actions.newLocation': 'Nova localização',
  'admin.actions.newUser': 'Novo utilizador',
  'admin.actions.newControllerVendor': 'Novo vendor do controlador',
  'admin.actions.newPmsVendor': 'Novo vendor PMS',
  'admin.actions.manageInfrastructure': 'Infraestrutura',
  'admin.actions.backToLocation': 'Voltar à localização',
  'admin.actions.backToList': 'Voltar à lista',
  'admin.actions.delete': 'Eliminar',
  'admin.infrastructure.inventory': 'Inventário de unidades',
  'admin.infrastructure.roomAssignments': 'Atribuições unitárias',
  'admin.infrastructure.roomAssignmentsDesc':
    'Cada quarto é mapeado individualmente com SSID, VLAN e modo PAN. Usa esta área para criar ou corrigir a atribuição de um único quarto.',
  'admin.infrastructure.locationScopeDesc':
    'Esta página pertence à localização selecionada. A atribuição da infraestrutura é gerida diretamente dentro da localização.',
  'admin.infrastructure.sharedSpaces': 'Unidades partilhadas e salas de eventos',
  'admin.infrastructure.noRooms': 'Nenhum quarto está configurado para a localização selecionada.',
  'admin.infrastructure.noSharedSpaces': 'Nenhuma unidade partilhada está configurada.',
  'admin.infrastructure.roomPreview': 'Pré-visualização da atribuição',
  'admin.infrastructure.readiness': 'Prontidão das integrações',
  'admin.integrations.queuePlaceholder': 'Redis / RabbitMQ por definir no backend',
  'admin.integrations.pdsPlaceholder': 'Configuração PDS por definir',
  'admin.form.createTenant': 'Criar tenant',
  'admin.form.updateTenant': 'Atualizar tenant',
  'admin.form.tenantNotFound': 'Tenant não encontrado.',
  'admin.form.createLocation': 'Criar localização',
  'admin.form.updateLocation': 'Atualizar localização',
  'admin.form.locationNotFound': 'Localização não encontrada.',
  'admin.form.createUser': 'Criar utilizador',
  'admin.form.updateUser': 'Atualizar utilizador',
  'admin.form.userNotFound': 'Utilizador não encontrado.',
  'admin.form.roomName': 'Quarto',
  'admin.form.ssid': 'SSID',
  'admin.form.vlanId': 'VLAN',
  'admin.form.serviceVlanId': 'VLAN de serviço',
  'admin.form.networkId': 'ID de rede',
  'admin.form.capacity': 'Capacidade',
  'admin.message.tenantSaved': 'Tenant {name} guardado.',
  'admin.message.tenantDeleted': 'Tenant {name} eliminado.',
  'admin.message.locationSaved': 'Localização {name} guardada.',
  'admin.message.locationDeleted': 'Localização {name} eliminada.',
  'admin.message.userSaved': 'Utilizador {name} guardado.',
  'admin.message.userDeleted': 'Utilizador {name} eliminado.',
  'admin.message.controllerVendorSaved': 'Vendor do controlador {name} criado.',
  'admin.message.pmsVendorSaved': 'Vendor PMS {name} criado.',
  'admin.message.controllerVendorUpdated': 'Vendor do controlador {name} atualizado.',
  'admin.message.pmsVendorUpdated': 'Vendor PMS {name} atualizado.',
  'admin.message.controllerVendorDeleted': 'Vendor do controlador {name} eliminado.',
  'admin.message.pmsVendorDeleted': 'Vendor PMS {name} eliminado.',
  'admin.message.roomDeleted': 'Quarto {name} eliminado.',
  'admin.confirm.deleteTenant': 'Eliminar o tenant {name} e todas as localizações associadas?',
  'admin.confirm.deleteLocation': 'Eliminar a localização {name} e a respetiva infraestrutura?',
  'admin.confirm.deleteUser': 'Eliminar o utilizador {name}?',
  'admin.confirm.deleteRoom': 'Eliminar o quarto {name}?',
  'admin.confirm.deleteControllerVendor': 'Eliminar o vendor do controlador {name}?',
  'admin.confirm.deletePmsVendor': 'Eliminar o vendor PMS {name}?',
  'reception.tab.events': 'Eventos',
  'reception.actions.sendEmail': 'Enviar por e-mail',
  'reception.message.emailed': 'Código {id} enviado por e-mail.',
  'events.kicker': 'Wi-Fi para eventos',
  'events.title': 'Criar e gerir acessos para eventos',
  'events.name': 'Nome do evento',
  'events.hall': 'Sala do evento',
  'events.duration': 'Duração',
  'events.code': 'Código do evento',
  'events.isolation': 'Isolamento de clientes',
  'events.network.loading': 'Carregando redes...',
  'events.network.empty': 'Nenhuma rede disponível',
  'events.network.loadError': 'Não foi possível carregar as redes',
  'events.isolated': 'Isolado',
  'events.shared': 'Acesso partilhado',
  'events.policy': 'Política',
  'events.contactName': 'Nome do contacto',
  'events.create': 'Novo evento',
  'events.edit': 'Editar evento',
  'events.sendEmail': 'Enviar o código por e-mail',
  'events.disable': 'Desativar evento',
  'events.empty': 'Não existem eventos configurados para esta localização.',
  'reception.tab.hotel': 'Hotel', 'reception.hotel.description': 'Códigos de quartos e áreas comuns do PMS ou Concierge', 'reception.hotel.kicker': 'Códigos Wi-Fi do hotel', 'reception.hotel.title': 'Gerir códigos de quartos e áreas comuns',
  'admin.onboarding.kicker': 'Registo guiado da localização', 'admin.onboarding.title': 'Criar e configurar uma nova localização', 'admin.onboarding.description': 'Siga pela ordem indicada a passagem do fornecedor para a Lumen.',
  'admin.onboarding.step1': 'Controlador', 'admin.onboarding.step2': 'Localização', 'admin.onboarding.step3': 'Integrações', 'admin.onboarding.step4': 'Revisão', 'admin.onboarding.step5': 'Revisão',
  'admin.onboarding.locationKicker': 'Passo 2 · Dados da localização', 'admin.onboarding.locationTitle': 'Introduzir os dados da nova localização',
  'admin.onboarding.controllerKicker': 'Passo 1 · Ligação ao fornecedor', 'admin.onboarding.controllerTitle': 'Configurar o controlador', 'admin.onboarding.controllerHelp': 'Hardware, RF, grupos AP e SSID base devem existir na plataforma do fornecedor.',
  'admin.onboarding.integrationsKicker': 'Passo 3 · Integrações opcionais', 'admin.onboarding.integrationsTitle': 'Configurar PMS, TV e e-mail', 'admin.onboarding.reviewKicker': 'Passo 4 · Revisão', 'admin.onboarding.reviewTitle': 'Confirmar a configuração', 'admin.onboarding.unitsNext': 'Depois de guardar, configure quartos, unidades partilhadas e salas de eventos com VLAN e rede.', 'admin.onboarding.saveContinue': 'Guardar e configurar unidades',
  'reception.fields.selectSpace': 'Selecionar uma unidade',
  'reception.category.journalist': 'Jornalista',
  'reception.category.relator': 'Orador',
  'reception.categoryDescription.staff': 'O código é criado na VLAN predefinida.',
  'reception.categoryDescription.iot': 'O código é criado na VLAN predefinida.',
  'reception.categoryDescription.visitor': 'O código é criado na VLAN predefinida.',
  'reception.categoryDescription.guest': 'Selecione o quarto para associar a respetiva VLAN.',
  'events.message.saved': 'Evento {name} guardado.',
  'events.message.emailSent': 'Código do evento enviado para {email}.',
  'events.message.disabled': 'Evento {name} desativado.',
  'events.codes.kicker': 'Gestão de hóspedes e visitantes',
  'events.codes.manage': 'Gerir códigos do evento',
  'events.codes.type': 'Tipo de código',
  'events.codes.mode': 'Modo de criação',
  'events.codes.personal': 'Pessoal',
  'events.codes.manual': 'Manual',
  'events.codes.bulk': 'Importação em massa',
  'events.codes.personalManual': 'Pessoal · Manual',
  'events.codes.personalBulk': 'Pessoal · Importação em massa',
  'events.codes.group': 'Grupo',
  'events.codes.manualTitle': 'Criar um código pessoal',
  'events.codes.bulkTitle': 'Importar códigos pessoais de um CSV',
  'events.codes.groupTitle': 'Criar um código de grupo',
  'events.codes.groupName': 'Nome do grupo',
  'events.codes.sendEmail': 'Enviar o código por e-mail',
  'events.codes.service': 'Serviço',
  'events.codes.serviceHint': 'Utilize a VLAN de serviço configurada para a sala do evento.',
  'events.codes.serviceUnavailable': 'A sala selecionada não tem uma VLAN de serviço configurada.',
  'events.codes.bulkHint': 'Colunas obrigatórias: firstName, lastName, email, category, devicesAllowed. A duração e a sala são herdadas do evento; o processamento é colocado em fila para respeitar os limites de pedidos do fornecedor.',
  'events.codes.createPersonal': 'Criar código pessoal',
  'events.codes.createGroup': 'Criar código de grupo',
  'events.codes.queueBulk': 'Colocar importação CSV em fila',
  'events.codes.personalCreated': 'Código pessoal criado: {code}',
  'events.codes.groupCreated': 'Código de grupo criado: {code}',
  'events.codes.bulkQueued': 'Importação {id} em fila: {imported} códigos processados.',
  'admin.unitsBulk.action': 'Importação em massa',
  'admin.unitsBulk.kicker': 'Importação em massa de unidades',
  'admin.unitsBulk.title': 'Importar unidades de CSV',
  'admin.unitsBulk.description': 'Crie quartos, áreas partilhadas e salas de eventos numa única operação.',
  'admin.unitsBulk.loadFile': 'Carregar CSV',
  'admin.unitsBulk.csv': 'CSV de unidades',
  'admin.unitsBulk.hint': 'Colunas: name, type, vlanId, serviceVlanId, networkId, panMode, capacity, assignment, status. Obrigatórias: name, type, vlanId, networkId.',
  'admin.unitsBulk.importing': 'A importar...',
  'admin.unitsBulk.import': 'Importar unidades',
  'admin.unitsBulk.completed': '{count} unidades importadas.',
  'admin.unitsBulk.invalid': 'CSV inválido: {error}',
  'admin.unitsBulk.noRows': 'Nenhuma linha de dados encontrada.',
  'admin.unitsBulk.missingColumns': 'Colunas em falta: {columns}.',
  'admin.unitsBulk.rowError': 'Valores inválidos na linha {row}.',
};
